import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { List, ListItem } from '@material-ui/core';
import { useRadiusFilter } from 'lib/hooks/useSrpFilters';
import { SrpRadiusFilterValue } from 'types/srpFilters';
import { useStyles } from './styles';

interface RadiusModalDropdownProps {
  onListItemClick?: (value: string) => void;
  setIsModalOpen?: (isOpen: boolean) => void;
}

const radiusOptions: SrpRadiusFilterValue[] = ['Any', 10, 25, 50, 100, 200, 300, 500];

export default function RadiusModal({
  onListItemClick,
  setIsModalOpen,
}: RadiusModalDropdownProps): JSX.Element {
  const { t } = useTranslation();
  const classes = useStyles();
  const { value, setValue } = useRadiusFilter();

  return (
    <List className={classes.radiusModal} role="button">
      {radiusOptions.map((radius, index) => {
        const isSelected = value === radius;
        const label = getRadiusLabel(t, radius);
        return (
          <ListItem
            key={index}
            className={classes.listItem}
            onClick={(): void => {
              onListItemClick?.(label);
              setValue(radius);
              setIsModalOpen?.(false);
            }}
            selected={isSelected}
            classes={{ selected: classes.selected }}
          >
            {isSelected && <div className={classes.selectedIcon} />}
            {label}
          </ListItem>
        );
      })}
    </List>
  );
}

export function getRadiusLabel(t: TFunction, value?: SrpRadiusFilterValue): string {
  if (value) {
    const valueString = value === 'Any' ? value : `${value.toString()} ${t('srp.miles')}`;
    return valueString;
  }
  return t('srp.locationFilter.selectRadius');
}
